import * as React from 'react';
import styled from 'styled-components';
import { tabletPortraitMinWidth } from '../../cssConstants';

interface Props {
	label?: string;
	color?: string;
	showCircle?: boolean;
	className?: string;
}

const CircleLabel = ({ label, color, showCircle = true, className }: Props) => {
	return (
		<Container>
			{showCircle && <Circle $color={color} />}
			<Label className={className} $color={color} $leftPadding={showCircle}>
				{label}
			</Label>
		</Container>
	);
};

export default CircleLabel;

const Container = styled.div`
	display: flex;
	align-items: center;
	padding-top: 10px;
`;

const Circle = styled.div<{ $color: string }>`
	width: 11px;
	height: 11px;
	border-radius: 50%;
	margin-right: 5px;
	background: ${(props) => props.$color};
`;

const Label = styled.span<{ $color: string; $leftPadding: boolean }>`
	font-size: 11px;
	font-weight: 500;
	padding: 5px 6px;
	padding-left: ${(props) => (props.$leftPadding ? '6px' : '0')};
	background: ${(props) => props.$color};
	color: transparent;
	background-clip: text;
	-webkit-background-clip: text;

	@media (min-width: ${tabletPortraitMinWidth}) {
		font-size: 12px;
	}
`;
